var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGithub(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 55.58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#00d6c3;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Front"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.81,54.08c0-1.66,0-7.42,0-9.7,0-3.29-1.13-5.45-2.39-6.54C40.28,37,48.5,34,48.5,20.41a13.69,13.69,0,0,0-3.61-9.48,12.76,12.76,0,0,0-.36-9.35S41.59.63,34.87,5.21a33.17,33.17,0,0,0-17.61,0C10.54.63,7.6,1.58,7.6,1.58a12.74,12.74,0,0,0-.35,9.35,13.66,13.66,0,0,0-3.62,9.48C3.63,34,11.86,37,19.69,37.84c-1.26,1.09-2.39,3.25-2.39,6.54,0,2.28,0,8,0,9.7M1.5,39.87c3.53.25,5.57,3.46,5.57,3.46,3.14,5.4,8.23,3.83,10.23,2.93"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.54f8ac15f3c9d9c2ba36df18756b3b09.svg";
export { ForwardRef as ReactComponent };